import React, {useLayoutEffect, useState} from "react";
import { AppBar, Box, useMediaQuery, useTheme } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Logo from "./Logo";
import HeaderRoutes from "./Tabs/HeaderTabs";
import WebFont from "webfontloader";
import { ReactComponent as LogoSVG } from "../../Images/logo.svg";
import {colorWhite} from "../../Constants/theme";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import BottomNav from "../BottomNav";
import {useLocation} from "react-router";
import {getBranding} from "../../redux/branding/branding.actions";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "fixed",
        backgroundColor: colorWhite,
        boxShadow: "0px",
        padding: "5px 30px",
        borderBottom: "1px solid #FAFAFA",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottomColor: "#E5E6F2",
        height: "48px",
        [theme.breakpoints.down("sm")]: {
            backgroundColor: colorWhite,
            borderBottom: "1px solid #FAFAFA",
            display: "flex",
            flexDirection: "row-reverse"
        },
    },
    tabWrapper: {
        position: "relative"
    },
    toolBar: {
        minHeight: "44px"
    },
    menuIcon: {
        display: "none",
        [theme.breakpoints.down("sm")]: {
            display: "flex"
        },
    },
    logoIconWrapper: {
        display: "none",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "130px",
            maxHeight: 48,
            color: "rgb(0%, 0%, 0%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
    },
    logIconA: {
        display: "flex",
        maxWidth: "140px",
    },
    logIcon: {
        maxHeight: 40,
        cursor: "pointer"
    },
}));
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const HomePage = () => {
    const classes = useStyles();
    const query = useQuery();
    const partnerId = query.get("partnerId");
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const [openDialog, setOpenDialog] = useState(false);
    const dispatch = useAppDispatch();
    const [brandingLoad, setBrandingLoad] = useState(false);
    const handleClick  = () => setOpenDialog(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    useLayoutEffect(() => {
        (async () => {
            if (partnerId) {
                await dispatch(getBranding(partnerId)).then((res) => {
                    WebFont.load({
                        google: {
                            families: [res.font?.header, res.font?.text]
                        }
                    });
                    setBrandingLoad(true);
                }
                )
                    .catch(err => {
                        setBrandingLoad(true);
                    }
                    );
            }
        })();
    }, []);
    return (
        !partnerId || brandingLoad ? <>
            <AppBar className={classes.root} elevation={0} >
                {/* <IconButton className={classes.menuIcon} onClick={handleClick}>
					< MenuIcon/>
				</IconButton> */}
                <Logo/>
                <Box className={classes.tabWrapper}>
                    <HeaderRoutes.HeaderTab />
                </Box>
                <HeaderRoutes.ResponsiveTabBar open={openDialog} handleClose={setOpenDialog} />
                <Box className={classes.logoIconWrapper}>
                    <a className={classes.logIconA} href={isWhiteLabel ? branding.redirectUrl: process.env.REACT_APP_APP_URL}>
                        { isWhiteLabel?
                            <img
                                src={branding.logo}
                                className={classes.logIcon}
                            />:
                            < LogoSVG />
                        }
                    </a>
                </Box>
            </AppBar>
            {isMobile &&
				<BottomNav />
            }
        </> :
            <></>
    );
};


export default HomePage;
